/**
 * Mode Rwd
 * @typedef {Object} IsiRWDMode
 * @property {Integer} Desktop Mode PC
 * @property {Integer} Tablet Mode tablette
 * @property {Integer} Phone Mode téléphone
*/
export enum IsiRWDMode {
    Desktop = 0,
    Tablet = 1,
    Phone = 2
};

window.IsiRWDMode = IsiRWDMode;

/**
 * Taille d'un device au sein de sa catégorie (phone/tablet/desktop)
 * @typedef {Object} IsiRWDLength
 * @property {Integer} Small
 * @property {Integer} Medium
 * @property {Integer} Large (Default)
*/
export enum IsiRWDLength {
    Small = 0,
    Medium = 1,
    Large = 2
};

window.IsiRWDLength = IsiRWDLength;

/**
 * Orientation Rwd
 * @typedef {Object} IsiRWDOrientation
 * @property {Integer} Portrait Portrait
 * @property {Integer} Landscape Paysage
*/
export enum IsiRWDOrientation {
    Landscape = 0,
    Portrait = 1
};

window.IsiRWDOrientation = IsiRWDOrientation;

/**
 * IIsiUnit
 * @typedef {Object} IIsiUnit
 * @property {Float} IsiValue Valeur
 * @property {UnitType} IsiType Unité
*/

/**
 * UnitType (unité d'un objet IIsiUnit)
 * @typedef {Object} UnitType
 * @property {Integer} Pixel px
 * @property {Integer} Point pt
 * @property {Integer} Percentage %
 * @property {Integer} Em em
*/
export enum UnitType {
    Pixel = 1,
    Point = 2,
    Percentage = 7,
    Em = 8
};

window.UnitType = UnitType;

// Les valeurs en string du la liste unittype
export enum UnitTypeAsString {
    Pixel = "px",
    Point = "pt",
    Pica = "pc",
    Inch = "in",
    Mm = "mm",
    Cm = "cm",
    Percentage = "%",
    Em = "em",
    Ex = "ex"
};

window.UnitTypeAsString = UnitTypeAsString;

/**
 * Nom du navigateur (Correspond enum VB)
 * @typedef {Object} WebBrowser
 * @property {String} InternetExplorer
 * @property {String} Edge
 * @property {String} Firefox
 * @property {String} Chrome
 * @property {String} Safari
 * @author MBRO
*/
export enum WebBrowser {
    InternetExplorer = 0,
    Edge = 1,
    Firefox = 2,
    Chrome = 3,
    Safari = 4
};

window.WebBrowser = WebBrowser;